import React from 'react';
import Particles from "../Particles/Particles";
import { GRAYSCALE_200, GRAYSCALE_500, NEUTRAL_100 } from "../../styles/colors";
import {
    Container,
    SectionTitle,
    ParticlesContainer,
    ProfileContainer,
    TextContainer,
    MerchantTitle,
    MerchantSubtitle
} from "./MerchantInformationDisplay.styles";

export type MerchantInformationDisplayProps = {
    title: string;
    subtitle: string;
    url?: string;
    sectionTitle?: string;
    profilePicture?: (props: {
        url?: string;
        placeholderIconFill: string;
        borderColor: string;
        backgroundColor: string;
    }) => React.ReactNode;
};

const MerchantInformationDisplay = ({
    title,
    subtitle,
    url,
    sectionTitle,
    profilePicture,
}: MerchantInformationDisplayProps) => {
    return (
        <Container $hasSectionTitle={!!sectionTitle}>
            {sectionTitle && (
                <SectionTitle>
                    {sectionTitle}
                </SectionTitle>
            )}
            {!sectionTitle && (
                <ParticlesContainer>
                    <Particles scale={0.8} />
                </ParticlesContainer>
            )}

            <ProfileContainer>
                {profilePicture?.({
                    url,
                    placeholderIconFill: GRAYSCALE_500,
                    borderColor: NEUTRAL_100,
                    backgroundColor: GRAYSCALE_200,
                })}
                <TextContainer>
                    <MerchantTitle>
                        {title}
                    </MerchantTitle>
                    <MerchantSubtitle>
                        {subtitle}
                    </MerchantSubtitle>
                </TextContainer>
            </ProfileContainer>
        </Container>
    )
}

export default MerchantInformationDisplay
